import React from 'react';

/* tslint:disable */
const SvgIconEmail = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 72 54' {...props}>
    <path d='M65.25 0H6.75A6.75 6.75 0 0 0 0 6.75v40.5A6.75 6.75 0 0 0 6.75 54h58.5A6.75 6.75 0 0 0 72 47.25V6.75A6.75 6.75 0 0 0 65.25 0zm0 6.75v5.74c-3.15 2.57-8.18 6.56-18.93 15C44 29.33 39.26 33.8 36 33.75s-8-4.42-10.32-6.29c-10.75-8.41-15.78-12.4-18.93-15V6.75zm-58.5 40.5v-26.1c3.22 2.57 7.79 6.17 14.76 11.62C24.58 35.19 30 40.53 36 40.5s11.32-5.23 14.49-7.73c7-5.45 11.54-9.05 14.76-11.62v26.1z' />
  </svg>
);
/* tslint:enable */

export default SvgIconEmail;

